export {DataTableHeadCell, dataTableHeadCellStyles} from './data-table-head-cell'
